import { render } from "./RestoreAttachBackupVolume.vue?vue&type=template&id=8627fd9e&scoped=true"
import script from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"
export * from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"

import "./RestoreAttachBackupVolume.vue?vue&type=style&index=0&id=8627fd9e&scoped=true&lang=less"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8627fd9e"]])

export default __exports__